import { system } from 'styled-system';

const borderLeftStyle = system({
  borderLeftStyle: {
    property: 'borderLeftStyle',
  },
});

export default borderLeftStyle;
